//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import PasswordDialog from '../PasswordDialog';
import logo_white from '~/assets/images/logo/logo_white.png';
import logo_blue from '~/assets/images/logo/logo_xianlin.png';
import config from '~/config';
import portal from '~/net/portal';
import { Identities } from '~/constant/Identities';
import { mobileList, navigationList, systemList } from '~/constant/home';
import { Area } from '~/constant/Area';
import { setToken, setCookie } from '~/utils/cookie';
export default {
  components: {
    PasswordDialog,
  },
  props: {
    navigationType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      timer: null,
      businessBrowserUrl: config.businessBrowserUrl,
      defaultImg: 'this.src="' + require('~/assets/images/head.png') + '"',
      Area,
      mobileList,
      navigationList,
      systemList,
      selectedArea: { name: '' },
      msgCount: 0,
      shop: null,
      unbindDialog: false,
      showRepresentate: false,
      hasShop: false,
      token: '',
      fillInfoVisible: false,
      sessionNaviType: '',
      lingyuList: [
        // { label: '全部', value: '全部' },
        { label: '生物医药(苏州)分中心', value: '生物医药(苏州)分中心' },
        { label: '生物医药(南京)分中心', value: '生物医药(南京)分中心' },
        { label: '信息通信(南京)分中心', value: '信息通信(南京)分中心' },
        { label: '先进材料(苏州)分中心', value: '先进材料(苏州)分中心' },
      ],
      lingyuList2: [
        {
          value: '01',
          label: '信息通信',
        },
        {
          value: '02',
          label: '生物医药',
        },
        {
          value: '04',
          label: '先进材料',
        },
      ],
      model: '',
      fuwuValue: '',
    };
  },
  computed: {
    ...mapState(['user', 'identities', 'courier']),
    pwdVisible: {
      get() {
        return this.$store.state.pwdVisible;
      },
      set(val) {
        this.$store.state.pwdVisible = val;
      },
    },
    realNameVisible: {
      get() {
        return this.$store.state.realNameVisible;
      },
      set(val) {
        this.$store.state.realNameVisible = val;
      },
    },
    identityVisible: {
      get() {
        return this.$store.state.identityVisible;
      },
      set(val) {
        this.$store.state.identityVisible = val;
      },
    },
    // isOnlyCollege() {
    //   return this.identities.length === 1 && this.menus.some(_ => _.text == '高校')
    // },
    getImage() {
      return logo_blue;
    },
    headPic() {
      // return decodeURIComponent(this.$absUrl(this.user.imgUrl))
      return '';
    },
    tip() {
      const list = [];
      this.identities.forEach((item) => {
        if (item.isBind != 2)
          // 被解绑的可以忽略
          list.push(Identities.find((_) => _.key == item.type));
      });
      return list
        .sort((a, b) => {
          return a.order - b.order;
        })
        .map((_) => _.value)
        .join(',');
    },
    menuVisibity() {
      return this.$config.AREA_CODE == 'jiangsu';
    },
    isCrowd() {
      return this.$route.path == '/crowdsourcing';
    },
    isActivity() {
      return this.$route.path == '/activity' || this.$route.path == '/yrd';
    },
    showBench() {
      if (this.user) {
        return this.user.userType == 1;
      } else return false;
    },
    showStaff() {
      if (this.user) {
        return this.user.userType != 1 && [2, 5].includes(this.user.userStatus);
      } else return false;
    },
    theme() {
      return (
        this.$route.path == '/' ||
        this.$route.path == '/crowdsourcing' ||
        this.$route.path == '/activity' ||
        this.$route.path == '/yrd'
      );
    },
    menus() {
      const array = [
        {
          text: '买家中心',
          role: 'buyer',
        },
      ];
      if (this.user == null) {
        array.push({
          text: '卖家中心',
          role: 'seller',
        });
      } else {
        const values = this.identities.map((_) => _.type);
        if (values.length > 0) {
          // 单独处理技术经理人解绑状态，需要增加卖家中心
          if (
            this.identities.length == 1 &&
            this.identities.find((_) => _.type == '01' && _.isBind == 2)
          ) {
            array.push({
              text: '卖家中心',
              role: 'seller',
            });
          }
          Identities.sort((a, b) => {
            return a.order - b.order;
          }).forEach((_) => {
            if (values.includes(_.key)) {
              const tmp = {
                text: _.alias || _.value,
                role: _.role,
              };
              // 服务商需要合并
              if (array.find((_) => _.text == tmp.text) == undefined) array.push(tmp);
            }
          });
        } else {
          array.push({
            text: '卖家中心',
            role: 'seller',
          });
        }
      }
      return array;
    },
  },
  mounted() {
    if (this.user) {
      this.timer = setInterval(() => {
        portal.getMessageCount().then((res) => {
          const { code, data } = res;
          if (code === '0000') {
            this.msgCount = data;
          }
        });
      }, 60000);
      if (this.showBench) {
        this.navigationList[2].linkArr.splice(5, 1, {
          name: '工作台',
          system: 'bcs',
          url: '/bench',
        });
      }
    }
    this.sessionNaviType = localStorage.getItem('navigationType');
    this.selectedArea = this.Area.find((_) => _.areacode == this.$config.AREA_CODE);
    setToken(this.$config.AREA_CODE);
    setCookie('tenantCode', this.selectedArea.tenantCode);
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    search() {
      const query = {
        keyword: this.fuwuValue,
        category: '',
      };
      this.$router.push({
        path: '/collegeSearch',
        query,
      });
    },

    goPages(url, query) {
      if (url.includes('http')) {
        window.open(url);
      } else {
        this.$router.push({
          path: url,
          query,
        });
      }
    },

    async getHasShop() {
      const { code, data } = await portal.getForMenus();
      if (code === '0000') {
        this.hasShop = data.hasShop;
      }
    },
    async getApplyStatus() {
      if (this.user == null) {
        this.$router.push('/login');
      } else {
        await this.getHasShop();
        const { code, data } = await portal.getApplyStatus();
        if (this.hasShop && data.status === '2') {
          this.goToCollege();
        } else if (this.menus.some((_) => _.text == '高校')) {
          window.location.href = `${this.businessBrowserUrl}/school`;
        } else {
          this.$Message.warning('暂无高校身份');
        }
      }
    },
    async goToCollege() {
      const { code, data } = await portal.goToCollege();
      if (code == '0000') {
        this.token = data;
        window.location.href = `https://college.jstec.com.cn/?token=${this.token}`;
      }
    },
    linkTo(item) {
      this.$store.dispatch('CheckRealName').then(
        async (res) => {
          this.goTo(item);
        },
        (err) => {
          if (err == null) {
            this.$router.push('/login');
          } else {
            this.goTo(item);
          }
        }
      );
    },
    goTo(item) {
      if (item.url === '/kefu') {
        this.$store.dispatch('consultCourierAdmin');
      } else if (item.system === 'bcs') {
        window.location.href = `${this.businessBrowserUrl}` + item.url;
      } else if (item.system === 'portal') {
        this.$router.push(item.url);
      }
    },
    goSystem(item) {
      let href;
      switch (item.system) {
        case 'bid':
          href = item.url;
          break;
        case 'bcs':
          href = `${this.businessBrowserUrl}` + item.url;
          break;
        case 'college':
          this.getApplyStatus();
          break;
        case 'jtop':
          this.$router.push(item.url);
          break;
        case 'analysis':
          href = item.url;
          break;
        default:
          this.$Message.warning('系统开发中，稍后上线');
          break;
      }

      if (href) {
        window.location.href = href;
      }
    },
    visibleChange(value, type) {
      new Map([
        [
          1,
          () => {
            return this.$store.commit('SET_REALNAME', value);
          },
        ],
        [
          2,
          () => {
            return this.$store.commit('SET_IDENTITYVISIBLE', value);
          },
        ],
        [
          3,
          () => {
            return this.$store.commit('SET_PWDVISIBLE', value);
          },
        ],
      ])
        .get(type)
        .call(this);
    },
    messageMenuClick(name) {
      if (name === 'message') {
        window.location.href = `${this.businessBrowserUrl}/message`;
      } else if (name === 'communication') {
        const { success, type } = this.courier.shop;
        if (success) {
          const url = `${this.businessBrowserUrl}/communication`;
          window.location.href = url;
        }
      }
    },
    sellerMenuClick(name) {
      this.goToBusinessCenter(name);
    },
    menuClick(name) {
      if (name == 'logout') {
        this.signout();
      } else if (name == 'bench') {
        window.location.href = `${this.businessBrowserUrl}/bench`;
      } else if (name == 'staff') {
        window.location.href = `${this.businessBrowserUrl}/staff`;
      } else if (name == 'personal') {
        portal.checkUserInfo().then((res) => {
          if (res.data) {
            window.location.href = `${this.businessBrowserUrl}/?custom=xianlin`;
          } else {
            this.fillInfoVisible = true;
          }
        });
      }
    },
    branchCenterClick(name) {
      this.selectedArea = this.Area.find((_) => _.areacode == name);
      if (this.selectedArea.areacode != this.$config.AREA_CODE) {
        window.location.href = `/goBranch/${this.selectedArea.areacode}`;
      }
    },
    signout() {
      this.$store.dispatch('LogOut').then((res) => {
        clearInterval(this.timer);
      });
      this.navigationList[2].linkArr.splice(5, 1, {
        name: '员工管理',
        system: 'bcs',
        url: '/staff',
      });
    },
    goToBusinessCenter(role) {
      this.$store.dispatch('CheckRealName').then(
        (res) => {
          const url = `${this.businessBrowserUrl}/business`;
          // if (role == 'technicalManager') {
          //     if (this.identities.some(_ => _.type == '01' && _.isBind == 2)) {
          //         this.unbindDialog = true // 经理人被解绑时可申诉
          //         this.showRepresentate = this.identities.find(_ => _.type == '01').flag || false
          //         return
          //     }
          // }
          window.location.href = url + `?role=${role}&from=portal`;
        },
        (err) => {
          if (err == null) {
            this.$router.push('/login');
          } else {
            this.$store.commit('SET_REALNAME', true);
          }
        }
      );
    },
    operateClick(value) {
      if (value === 1) {
        this.realNameVisible = false;
        window.location.href = `${this.businessBrowserUrl}/realname`;
      } else if (value === 2) {
        this.identityVisible = false;
        window.location.href = `${this.businessBrowserUrl}/identity`;
      } else if (value === 3) {
        this.fillInfoVisible = false;
        window.location.href = `${this.businessBrowserUrl}/person`;
      }
    },
    async representateAsync() {
      const { code } = await portal.representate({
        query: {
          id: this.user.id,
        },
      });
      if (code == '0000') {
        this.$Message.success('您的申诉已告知平台！');
        this.unbindDialog = false;
      }
    },
  },
};
